import { registerRoute } from "../server";
import { Tag } from "../../index";

export default function registerRoutes() {
  registerRoute({
    id: "tag",
    route: "tag",
    method: "get", // the OPTIONS request won't be sent when Mirage is handling the route
    generateResponse: function (config, schema, request) {
      const queryParams = request.queryParams;
      let result = (schema as any).tags.all();
      if (queryParams) {
        if (queryParams.query) {
          result = (schema as any).tags.where((item: Tag) => {
            return item.name?.match(new RegExp(queryParams.query, "i"));
          });
        }
      }
      // Limit to first 10
      result.models = result.models.slice(0, 10);
      return result;
    },
  });
}
